@if((!fileUploading && !fileSizeError && !fileTypeError)){
<div
  class="orgApp-file-upload orgApp-text-center orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center orgApp-file-upload-area orgApp-file-upload-drop-area"
  [style.minHeight.px]="height"
  [style.width.px]="width"
>
  <div fileDragDrop (filesChangeEmiter)="onFileChange($event,'drag')"
    class="orgApp-d-flex orgApp-flex-dir-col orgApp-file-upload-details"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
    [style.minHeight.px]="fileAreaHeight"
    [style.width.px]="fileAreaWidth"
  >
    <input type="file" name="file" id="file" (change)="onFileChange($event,'upload')" />
    @if(!apiImgAvlbl){
      <div>
        <svg width="44" height="44" class="orgApp-file-upload-icon">
          <use xlink:href="#file-upload"></use>
        </svg>
      </div>

      <label for="file"
      ><span
        class="orgApp-file-upload-details-textLink orgApp-file-upload-details-text"
        >{{"staff.customDialog1.file_upload.label.upload"|translate}}</span
      ></label
    >
    <p class="orgApp-file-upload-details-text orgApp-fu-dtls-txt-sz">({{"staff.customDialog1.file_upload.label.file_size"|translate}}: 50KB)</p>
    <p class="orgApp-file-upload-details-text orgApp-fu-dtls-txt-sz">({{"staff.customDialog1.file_upload.label.file_type"|translate}}: png,webp,jpg,jpeg)</p>
    }
  </div>
</div>
}
@if((fileUploading || fileSizeError || fileTypeError) && !apiImgAvlbl){
<div
  class="orgApp-file-upload orgApp-text-center orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center orgApp-file-upload-file-name-div orgApp-file-upload-area"
  [style.minHeight.px]="height"
  [style.width.px]="width"
>
  @if(fileUploading && !fileSizeError && !fileTypeError && !apiImgAvlbl){
  <div
    class="orgApp-file-upload-details orgApp-file-upload-width-full"
    [style.minHeight.px]="fileAreaHeight"
    [style.width.px]="fileAreaWidth"
  >
    <div class="orgApp-d-flex orgApp-align-i-center">
      <p class="orgApp-file-upload-details-file-name">
        {{ selectedFileName }}
      </p>
      @if(uploadProgress === 100 && uploadProgress !== null){
        <svg width="24" height="24" viewBox="0 0 24 24">
          <use xlink:href="#green-checked"></use>
        </svg>
      }
      @if(uploadProgress === null){
        <!-- currently not used -->
      <mat-icon
        (click)="deleteUploadedFile()"
        class="orgApp-file-upload-action-icon"
        >delete</mat-icon
      >}
    </div>
    <p class="orgApp-file-upload-details-file-size">{{ fileSizeInKb }} KB</p>
    @if(uploadProgress === null){
    <p>
      <span class="orgApp-file-upload-details-textLink" (click)="viewFile()"
        >{{"staff.customDialog1.file_upload.label.view_file"|translate}}</span
      >
    </p>
    }
    <div class="orgApp-file-upload-details-prog-div">
      @if(uploadProgress !== null){
      <mat-progress-bar
        class="orgApp-file-upload-prog-bar"
        class="{{ uploadProgress === 100 ? 'green-bar' : 'blue-bar' }}"
        [value]="uploadProgress"
      >
      </mat-progress-bar>
    }
    @if(uploadProgress !== null){
    <span>{{ uploadProgress }}%</span>
    }  
    </div>
  </div>
}
  @if(fileUploading && (fileSizeError || fileTypeError) && !apiImgAvlbl){
  <div
    [style.minHeight.px]="height"
    [style.width.px]="width"
    class="orgApp-file-upload-details orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center orgApp-file-upload-file-failed"
  >
    <div>
      <svg width="44" height="44" class="orgApp-file-upload-icon">
        <use xlink:href="#file-upload-failed"></use>
      </svg>
    </div>
    <label for="file"
      ><span
        class="orgApp-file-upload-details-textLink orgApp-file-upload-details-text orgApp-file-upload-file-failed-color"
        >{{"staff.customDialog1.file_upload.label.upload_fail"|translate}}</span
      ></label
    >
    <p class="orgApp-file-upload-details-text orgApp-fu-dtls-txt-sz">({{"staff.customDialog1.file_upload.label.file_size"|translate}}: 50KB)</p>
    <p class="orgApp-file-upload-details-text orgApp-fu-dtls-txt-sz">({{"staff.customDialog1.file_upload.label.file_type"|translate}}: png,webp,jpg,jpeg)</p>
    @if(uploadProgress === null){
    <p>
      <span
        class="orgApp-file-upload-details-textLink orgApp-file-upload-file-failed-color"
        (click)="retryFileUpload()"
        >{{"staff.customDialog1.file_upload.label.try_again"|translate}}</span
      >
    </p>
    }
    <div class="orgApp-file-upload-details-prog-div">
      @if(uploadProgress !== null){
      <mat-progress-bar
        class="orgApp-file-upload-prog-bar"
        class="{{ uploadProgress === 100 ? 'green-bar' : 'blue-bar' }}"
        [value]="uploadProgress"
      >
      </mat-progress-bar>
    }
      @if(uploadProgress !== null){
      <span>{{ uploadProgress }}%</span>
      }
    </div>
  </div>
}
</div>
}